import { FileHandler } from './FileHandler';
import { FileRevisionHandler } from './FileRevisionHandler';
import { UrlHandler } from './UrlHandler';

export const handlers = [FileHandler, FileRevisionHandler, UrlHandler];
